export function IconInstagram() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
    >
      <path
        d="M17.5524 0H7.44764C3.34099 0 0 3.34099 0 7.44764V17.5524C0 21.659 3.34099 25 7.44764 25H17.5524C21.659 25 25 21.659 25 17.5524V7.44764C25 3.34099 21.659 0 17.5524 0ZM22.485 17.5524C22.485 20.2766 20.2766 22.485 17.5524 22.485H7.44764C4.72344 22.485 2.515 20.2766 2.515 17.5524V7.44764C2.515 4.72339 4.72344 2.515 7.44764 2.515H17.5524C20.2766 2.515 22.485 4.72339 22.485 7.44764V17.5524Z"
        fill="url(#paint0_linear_40_631)"
      />
      <path
        d="M12.5 6.03418C8.93471 6.03418 6.03412 8.93477 6.03412 12.5C6.03412 16.0653 8.93471 18.9659 12.5 18.9659C16.0653 18.9659 18.9659 16.0653 18.9659 12.5C18.9659 8.93473 16.0653 6.03418 12.5 6.03418ZM12.5 16.451C10.318 16.451 8.54912 14.6821 8.54912 12.5001C8.54912 10.318 10.318 8.54918 12.5 8.54918C14.682 8.54918 16.4509 10.318 16.4509 12.5001C16.4509 14.6821 14.682 16.451 12.5 16.451Z"
        fill="url(#paint1_linear_40_631)"
      />
      <path
        d="M18.9784 7.63192C19.8341 7.63192 20.5277 6.93825 20.5277 6.08256C20.5277 5.22688 19.8341 4.5332 18.9784 4.5332C18.1227 4.5332 17.429 5.22688 17.429 6.08256C17.429 6.93825 18.1227 7.63192 18.9784 7.63192Z"
        fill="url(#paint2_linear_40_631)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_40_631"
          x1="12.5"
          y1="24.9272"
          x2="12.5"
          y2="0.194179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_40_631"
          x1="12.5"
          y1="24.9273"
          x2="12.5"
          y2="0.19425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_40_631"
          x1="18.9784"
          y1="24.9271"
          x2="18.9784"
          y2="0.194088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function IconClock() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
    >
      <g clipPath="url(#clip0_571_35)">
        <path
          d="M3.83003 38.5375C3.69566 38.3544 4.08378 37.055 4.16253 36.9619C6.20691 34.5819 6.28191 26.9244 6.24003 25.8331C6.13753 23.3144 7.47253 20.7669 8.59878 21.3175C9.68628 21.8488 10.5388 27.0863 10.7482 28.1344C11.265 30.6975 11.0625 33.7656 10.2325 36.1956C9.35628 38.7688 5.96941 41.38 3.83003 38.5375ZM36.2344 38.5375C36.3682 38.3544 35.9807 37.055 35.9013 36.9619C33.8569 34.5819 33.7825 26.9244 33.8244 25.8331C33.9263 23.3144 32.5913 20.7669 31.465 21.3175C30.3782 21.8488 29.5257 27.0863 29.3163 28.1344C28.7994 30.6975 29.0019 33.7656 29.8319 36.1956C30.7075 38.7688 34.0944 41.38 36.2344 38.5375Z"
          fill="#97CC3B"
        />
        <path
          d="M1.51305 10.8336C2.86305 12.1843 6.04117 11.1918 8.61742 8.6149C11.1924 6.0399 12.1849 2.86302 10.8349 1.51177C9.48805 0.166146 4.07617 -1.0751 1.49992 1.4999C-1.07508 4.0749 0.166171 9.48802 1.51305 10.8336ZM38.3874 10.8336C37.038 12.1843 33.8599 11.1918 31.2837 8.6149C28.7087 6.0399 27.7162 2.86302 29.0655 1.51177C30.413 0.166146 35.8243 -1.0751 38.4005 1.4999C40.9755 4.0749 39.7343 9.48802 38.3874 10.8336Z"
          fill="#8FC533"
        />
        <path
          d="M38.0057 20.6688C38.0057 30.6556 29.9119 38.7513 19.9244 38.7513C9.9369 38.7513 1.84253 30.6563 1.84253 20.6688C1.84253 10.6838 9.93628 3.73126 19.9238 3.73126C29.9113 3.73126 38.0057 10.6831 38.0057 20.6688Z"
          fill="#FF7324"
        />
        <path
          d="M33.4562 20.8125C33.4562 28.2881 27.3975 34.3475 19.9212 34.3475C12.445 34.3475 6.38623 28.2881 6.38623 20.8125C6.38623 13.3387 12.4456 8.13562 19.9212 8.13562C27.3969 8.13562 33.4562 13.3387 33.4562 20.8125Z"
          fill="#E7E6E6"
        />
        <path
          d="M21.5968 21.9563C21.5968 23.0538 20.7249 23.9413 19.6487 23.9413C18.5724 23.9413 17.7006 23.0538 17.7006 21.9563V12.6275C17.7006 11.5331 18.5724 10.6456 19.6487 10.6456C20.7256 10.6456 21.5968 11.5331 21.5968 12.6275V21.9563Z"
          fill="#6D6D6D"
        />
        <path
          d="M19.7656 23.9437C18.6231 23.9437 17.7 23.3387 17.7 22.5931C17.7 21.8494 18.6231 21.245 19.7656 21.245H29.4887C30.6306 21.245 31.5562 21.8494 31.5562 22.5931C31.5562 23.3387 30.6312 23.9437 29.4887 23.9437H19.7656Z"
          fill="#6D6D6D"
        />
      </g>
      <defs>
        <clipPath id="clip0_571_35">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconVegetable() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
    >
      <path
        d="M36.1274 10.4513L36.1149 10.4638C36.8515 11.3585 37.2288 12.4953 37.1734 13.6529C37.1179 14.8105 36.6337 15.9061 35.8149 16.7263C35.3831 17.1601 34.8698 17.5043 34.3046 17.7392C33.7393 17.9741 33.1333 18.095 32.5212 18.095C31.9091 18.095 31.303 17.9741 30.7378 17.7392C30.1725 17.5043 29.6593 17.1601 29.2274 16.7263C28.4606 15.9628 27.9841 14.9558 27.8799 13.8788L25.6249 16.135L23.8562 14.3675L26.0387 12.1863C25.026 12.0521 24.0861 11.5872 23.3649 10.8638C22.9311 10.4319 22.5869 9.91866 22.352 9.35342C22.1171 8.78818 21.9962 8.18211 21.9962 7.57001C21.9962 6.95791 22.1171 6.35184 22.352 5.7866C22.5869 5.22137 22.9311 4.70809 23.3649 4.27626C24.1672 3.47413 25.2345 2.99221 26.3667 2.92087C27.499 2.84954 28.6183 3.19368 29.5149 3.88876L29.5399 3.86376C31.3524 2.03876 34.3024 2.05126 36.1274 3.86376C36.5612 4.29559 36.9055 4.80887 37.1403 5.3741C37.3752 5.93934 37.4961 6.54541 37.4961 7.15751C37.4961 7.76961 37.3752 8.37568 37.1403 8.94092C36.9055 9.50616 36.5612 10.0194 36.1274 10.4513V10.4513Z"
        fill="#8FC533"
      />
      <path
        d="M5.80245 37.3638L25.4899 30.9888C31.1274 29.1638 32.8399 22.0263 28.6524 17.8388L22.1524 11.3388C17.9649 7.15129 10.8274 8.87629 9.00245 14.5013L2.62745 34.1888C1.98995 36.1513 3.83995 38.0013 5.80245 37.3638V37.3638Z"
        fill="#F99C1D"
      />
      <path
        d="M15.4662 24.2638C16.0787 23.6513 16.0787 22.6638 15.4662 22.0388L8.74119 15.3138L7.65369 18.6638L13.2412 24.2513C13.8537 24.8763 14.8537 24.8763 15.4662 24.2638ZM10.7412 29.9513C10.1287 30.5638 10.1287 31.5513 10.7412 32.1763L13.4537 34.8888L16.8037 33.8013L12.9537 29.9513C12.8085 29.8058 12.6361 29.6903 12.4463 29.6116C12.2565 29.5328 12.053 29.4922 11.8474 29.4922C11.6419 29.4922 11.4384 29.5328 11.2486 29.6116C11.0588 29.6903 10.8863 29.8058 10.7412 29.9513V29.9513ZM20.3162 23.7263C19.7037 23.1013 19.7037 22.1138 20.3162 21.5013C20.9287 20.8888 21.9162 20.8888 22.5412 21.5138L29.3287 28.3013C28.7037 29.1263 27.9037 29.8263 26.9537 30.3638L20.3162 23.7263V23.7263Z"
        fill="#ED6C31"
      />
    </svg>
  );
}

export function IconHealthy() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
    >
      <path
        d="M5 27.5V32.5C5 33.8807 6.11929 35 7.5 35H12.5"
        stroke="#97CC3B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 35H32.5C33.8807 35 35 33.8807 35 32.5V27.5"
        stroke="#97CC3B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 12.5V7.5C35 6.11929 33.8807 5 32.5 5H27.5"
        stroke="#97CC3B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12.5V7.5C5 6.11929 6.11929 5 7.5 5H12.5"
        stroke="#97CC3B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3333 20.0001L20 28.3334C20 28.3334 12.5002 20.8334 11.6667 20.0001C10.8332 19.1667 10.4167 17.5001 11.6667 15.8334C12.9167 14.1667 15.4167 14.1667 16.6667 15.0001C17.9167 15.8334 18.3334 16.6667 20 16.6667C21.6667 16.6667 22.0834 15.8334 23.3333 15.0001C24.5833 14.1667 27.0836 14.1667 28.3336 15.8334C29.5836 17.5001 29.1667 19.1667 28.3333 20.0001Z"
        fill="#FF7324"
        stroke="#FF7324"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconDuration() {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
      <g clipPath="url(#a)">
        <path
          d="M30 9.783c.717 0 1.304-.587 1.304-1.305v-.652c0-.717-.587-1.304-1.304-1.304-.718 0-1.305.587-1.305 1.304v.652c0 .718.587 1.305 1.305 1.305Z"
          fill="url(#b)"
        />
        <path
          d="M30 50.217c-.718 0-1.305.587-1.305 1.305v.652c0 .717.587 1.304 1.305 1.304.717 0 1.304-.587 1.304-1.304v-.652c0-.718-.587-1.305-1.304-1.305Z"
          fill="url(#c)"
        />
        <path
          d="M8.478 28.696h-.652c-.718 0-1.305.587-1.305 1.304 0 .717.587 1.304 1.305 1.304h.652c.717 0 1.304-.587 1.304-1.304 0-.717-.587-1.304-1.304-1.304Z"
          fill="url(#d)"
        />
        <path
          d="M52.174 28.696h-.652c-.717 0-1.304.587-1.304 1.304 0 .717.587 1.304 1.304 1.304h.652c.718 0 1.305-.587 1.305-1.304 0-.717-.587-1.304-1.305-1.304Z"
          fill="url(#e)"
        />
        <path
          d="M15.261 13.435a1.26 1.26 0 0 0-1.826 0 1.26 1.26 0 0 0 0 1.826l.457.456c.26.261.587.392.913.392.326 0 .652-.13.913-.392a1.261 1.261 0 0 0 0-1.826l-.457-.456Z"
          fill="url(#f)"
        />
        <path
          d="m13.892 44.283-.457.456a1.26 1.26 0 0 0 0 1.826c.261.261.587.392.913.392.326 0 .652-.13.913-.392l.457-.456a1.261 1.261 0 0 0 0-1.826 1.261 1.261 0 0 0-1.826 0Z"
          fill="url(#g)"
        />
        <path
          d="m44.74 13.435-.457.456a1.261 1.261 0 0 0 0 1.826c.26.261.587.392.913.392.326 0 .652-.13.913-.392l.456-.456a1.26 1.26 0 0 0 0-1.826 1.26 1.26 0 0 0-1.826 0Z"
          fill="url(#h)"
        />
        <path
          d="M31.304 29.478v-11.87c0-.717-.587-1.304-1.304-1.304-.718 0-1.305.587-1.305 1.305V30c0 .326.13.652.392.913l14.282 14.283c.261.26.587.391.913.391.326 0 .652-.13.913-.391a1.261 1.261 0 0 0 0-1.826L31.304 29.478Z"
          fill="url(#i)"
        />
        <path
          d="M30 0C13.435 0 0 13.435 0 30c0 16.565 13.435 30 30 30 16.565 0 30-13.435 30-30C60 13.435 46.565 0 30 0Zm0 57.391C14.87 57.391 2.609 45.131 2.609 30 2.609 14.87 14.869 2.609 30 2.609c15.13 0 27.391 12.26 27.391 27.391 0 15.13-12.26 27.391-27.391 27.391Z"
          fill="url(#j)"
        />
      </g>
      <defs>
        <linearGradient id="b" x1={30} y1={6.522} x2={30} y2={9.783} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={30}
          y1={50.217}
          x2={30}
          y2={53.478}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={8.152}
          y1={28.696}
          x2={8.152}
          y2={31.304}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={51.848}
          y1={28.696}
          x2={51.848}
          y2={31.304}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={14.577}
          y1={13.043}
          x2={14.577}
          y2={16.109}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={14.577}
          y1={43.891}
          x2={14.577}
          y2={46.956}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={45.424}
          y1={13.043}
          x2={45.424}
          y2={16.109}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={37.141}
          y1={16.304}
          x2={37.141}
          y2={45.587}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient id="j" x1={30} y1={0} x2={30} y2={60} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h60v60H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconIngredients() {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
      <g clipPath="url(#a)">
        <path d="M44 41h-6v2h6v-2Z" fill="url(#b)" />
        <path d="M10.167 22h-5v2h5v-2Z" fill="url(#c)" />
        <path d="M11.167 27h-5v2h5v-2Z" fill="url(#d)" />
        <path d="M28 21h-2v4h2v-4Z" fill="url(#e)" />
        <path d="M32 28h-2v4h2v-4Z" fill="url(#f)" />
        <path
          d="M22.43 16.177a8.982 8.982 0 0 0-3.38 4.506 8.982 8.982 0 0 0 0 5.633l1.898-.633a6.955 6.955 0 0 1 0-4.367 6.965 6.965 0 0 1 2.62-3.494l-1.138-1.645Z"
          fill="url(#g)"
        />
        <path
          d="M59 34h-3.54A5.97 5.97 0 0 0 57 30a5.91 5.91 0 0 0-.725-2.824A6.943 6.943 0 0 0 60 21a7.018 7.018 0 0 0-3.796-6.22 5.326 5.326 0 0 0 .796-2.78c0-3.018-2.612-5.522-6-5.939v-.061c0-3.309-3.14-6-7-6s-7 2.691-7 6v.061c-2.947.363-5.304 2.305-5.869 4.79-1.558-1.174-3.294-1.851-5.13-1.851-3.44 0-6.538 2.316-8.728 6H13l4.8-6.4-1.6-1.2-4.2 5.6v-10h-2v10l-4.2-5.6-1.6 1.2 4.8 6.4H7.064a6.937 6.937 0 0 0-5.616 2.82 6.937 6.937 0 0 0-1.088 6.19L3.356 34H1a1 1 0 0 0-.832 1.554l16 24A1 1 0 0 0 17 60h27a1 1 0 0 0 .848-.47l5.625-9 5-8 4.375-7A1 1 0 0 0 59 34ZM38 8.003c-.004.012.101.004.122.004a1.003 1.003 0 0 0 .971-1.238A3.2 3.2 0 0 1 39 6.001c0-2.206 2.243-4 5-4s5 1.794 5 4a3.2 3.2 0 0 1-.093.767 1.002 1.002 0 0 0 .971 1.238L50 8.001c2.757 0 5 1.794 5 4 0 .92-.386 1.787-1.115 2.507a1.003 1.003 0 0 0 .438 1.677A5.007 5.007 0 0 1 58 21a4.967 4.967 0 0 1-3.542 4.769 1.001 1.001 0 0 0-.461 1.615A3.938 3.938 0 0 1 55 30c0 2.206-1.794 4-4 4h-6v-3.586l3.707-3.707-1.414-1.414L45 27.587v-4.172l3.707-3.707-1.414-1.414L45 20.587v-4.172l3.707-3.707-1.414-1.414L45 13.587V9.001h-2v4.586l-2.293-2.293-1.414 1.414L43 16.415v4.172l-2.293-2.293-1.414 1.414L43 23.415v4.172l-2.293-2.293-1.414 1.414L43 30.415V34h-5.604c.02-.095.033-.192.052-.287.038-.192.071-.386.105-.58a28.292 28.292 0 0 0 .355-2.873c.013-.18.03-.357.04-.536C37.98 29.153 38 28.58 38 28c0-.716-.03-1.421-.079-2.117-.017-.236-.046-.467-.068-.702-.043-.45-.089-.898-.15-1.337-.043-.3-.095-.594-.146-.89a26.832 26.832 0 0 0-.439-2.074c-.057-.224-.12-.443-.182-.663-.842-2.991-2.148-5.634-3.854-7.6l-.028-.146c-.025-.155-.054-.31-.054-.471 0-2.205 2.242-3.999 5-3.999Zm-19.306 8.48a.993.993 0 0 0 .073-.187C20.59 13.04 23.155 11 26 11c1.971 0 3.805.987 5.355 2.667.02.025.032.055.053.078 1.787 1.974 3.124 4.78 3.882 8 .015.065.028.13.042.196a26.614 26.614 0 0 1 .55 3.57c.014.17.033.338.045.509.045.653.073 1.313.073 1.98 0 2.07-.219 4.085-.65 6H23v-3h-2v3h-4.336c-.038-.166-.077-.332-.11-.5a22.807 22.807 0 0 1-.276-1.606c-.029-.21-.06-.416-.086-.627-.042-.358-.07-.72-.099-1.082-.014-.18-.033-.357-.043-.537A28.096 28.096 0 0 1 16 28c0-.553.018-1.1.05-1.638.02-.363.056-.722.09-1.08.015-.16.025-.32.043-.477.354-3.078 1.215-5.958 2.511-8.324ZM2.275 23.438a4.953 4.953 0 0 1 .777-4.421A4.953 4.953 0 0 1 7.064 17h9.143a22.912 22.912 0 0 0-.734 1.892l-.04.116c-.167.493-.32.995-.46 1.509l-.037.13a27.495 27.495 0 0 0-.386 1.666c-.016.082-.028.166-.043.249-.086.457-.16.919-.226 1.386-.026.186-.047.374-.069.562-.047.396-.085.794-.116 1.196-.014.184-.03.366-.04.55A30.506 30.506 0 0 0 14 28.002c0 .578.02 1.152.052 1.722.01.18.027.36.04.54.03.392.063.782.107 1.169.023.203.05.404.077.605.05.369.107.734.171 1.097.034.194.067.388.105.58.02.096.032.193.052.287h-9.16L2.275 23.438ZM54.071 41h-7.07v2h5.82l-3.75 6h-19.07v2h17.82l-4.375 7h-25.91L2.868 36H33.943c.15.014.397.022.881.022.396 0 .951-.006 1.742-.017L51 36h6.196l-3.125 5Z"
          fill="url(#h)"
        />
      </g>
      <defs>
        <linearGradient id="b" x1={41} y1={41} x2={41} y2={43} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient id="c" x1={7.667} y1={22} x2={7.667} y2={24} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient id="d" x1={8.667} y1={27} x2={8.667} y2={29} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient id="e" x1={27} y1={21} x2={27} y2={25} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient id="f" x1={31} y1={28} x2={31} y2={32} gradientUnits="userSpaceOnUse">
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={21.083}
          y1={16.177}
          x2={21.083}
          y2={26.316}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={30}
          y1={0.001}
          x2={30}
          y2={60.001}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h60v60H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconChef() {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
      <g clipPath="url(#a)">
        <path
          d="M8.478 33.771a.886.886 0 1 0 1.236 1.268c1.77-1.725 1.045-3.145.565-4.085-.45-.881-.637-1.247.313-2.14a.885.885 0 0 0-1.214-1.29c-1.918 1.805-1.17 3.268-.676 4.237.432.846.611 1.196-.224 2.01Z"
          fill="url(#b)"
        />
        <path
          d="M13.38 29.023a.886.886 0 1 0 1.236 1.268c1.771-1.726 1.045-3.146.563-4.085-.451-.882-.638-1.247.312-2.14a.885.885 0 1 0-1.214-1.29c-1.919 1.805-1.17 3.268-.674 4.237.433.846.612 1.196-.223 2.01Z"
          fill="url(#c)"
        />
        <path
          d="M26.393 24.003c.23 0 .459-.088.632-.266.289-.256 1.578-.253 1.863.003a.886.886 0 1 0 1.256-1.248c-.64-.645-1.735-.718-2.195-.718h-.018c-.442.002-1.538.076-2.17.723a.887.887 0 0 0 .632 1.506Z"
          fill="url(#d)"
        />
        <path
          d="M33.566 24.003a.88.88 0 0 0 .632-.266c.288-.256 1.578-.253 1.863.003a.886.886 0 1 0 1.256-1.248c-.64-.645-1.735-.718-2.195-.718h-.018c-.442.002-1.538.076-2.17.723a.887.887 0 0 0 .632 1.506Z"
          fill="url(#e)"
        />
        <path
          d="M31.627 13.142a.885.885 0 0 0 .885-.886V8.19a.885.885 0 0 0-1.77 0v4.067c0 .49.396.886.885.886Z"
          fill="url(#f)"
        />
        <path
          d="M25.614 9.142a.885.885 0 0 0-.886.886v4.064a.885.885 0 0 0 1.772 0v-4.064a.886.886 0 0 0-.886-.886Z"
          fill="url(#g)"
        />
        <path
          d="M37.64 14.977a.885.885 0 0 0 .885-.886v-4.064a.885.885 0 0 0-1.771 0v4.064c0 .49.396.886.886.886Z"
          fill="url(#h)"
        />
        <path
          d="M56.564 32.342A3.441 3.441 0 0 0 60 28.902v-7.71a3.441 3.441 0 0 0-3.436-3.439h-3.76a3.441 3.441 0 0 0-3.436 3.438v7.712a3.441 3.441 0 0 0 3.436 3.439h.995v12.401h-.734c-.253 0-.5.032-.734.092l-.845-3.58c-.982-4.162-4.44-6.413-10.276-6.69h-.012c-.47-.015-.872-.1-1.227-.268l-.04-.02c-.423-.21-.78-.543-1.108-1.025.188-.145.375-.294.556-.448 2.56-2.186 3.97-4.96 3.97-7.81v-5.701a.85.85 0 0 0 0-.258v-5.813c1.658-1.216 2.343-2.954 1.835-4.73-.62-2.166-2.83-3.679-5.377-3.679H37.31c-.77-1.777-2.446-2.934-4.602-3.14-2.615-.25-5.16.997-6.504 3.14h-2.386c-2.583 0-4.826 1.535-5.455 3.733-.502 1.757.17 3.475 1.804 4.676v12.232c0 2.986 1.82 5.335 3.346 6.78.365.346.753.676 1.155.987-.336.5-.7.845-1.135 1.06a.016.016 0 0 1-.003.001c-.363.179-.774.267-1.258.283h-.012a20.491 20.491 0 0 0-2.529.27c-3.854.669-6.344 2.462-7.424 5.352H2.993a2.998 2.998 0 0 0 0 5.994h2.302a12.667 12.667 0 0 0 4.004 5.133h-.861a2.62 2.62 0 0 0-2.617 2.618v1.809a2.62 2.62 0 0 0 2.617 2.618h5.187a.885.885 0 0 0 0-1.77H8.438a.847.847 0 0 1-.846-.848v-1.809c0-.467.38-.847.846-.847h18.445a.848.848 0 0 1 .846.847v1.809c0 .467-.38.847-.846.847h-9.224a.885.885 0 0 0 0 1.771h9.224a2.62 2.62 0 0 0 2.617-2.618V54.55h20.602a2.973 2.973 0 0 0 2.963 2.83h1.619a4.593 4.593 0 0 0 4.586-4.588v-3.46a4.595 4.595 0 0 0-3.7-4.502V32.342h.994Zm-6.802 9.32.99 4.195a2.956 2.956 0 0 0-.653 1.855v5.067H47.58l-1.448-8.385c-.179-1.067-.792-1.871-1.62-2.206v-5.383c2.931.75 4.66 2.355 5.25 4.858Zm-7.021-5.188v5.545h-2.27v-5.745c.21.032.43.053.661.061.565.027 1.1.074 1.609.14Zm-8.313 5.545a3.002 3.002 0 0 0-2.761-1.832h-6.83v-2.7c1.69 1.233 4.14 1.784 6.288 1.866.187.008.379.011.573.011 2.337 0 5.1-.536 7.002-1.953v4.608h-4.273Zm-4.275 1.718c.146-.66.165-1.263.062-1.78h1.452a1.226 1.226 0 0 1 0 2.452h-1.683c.062-.222.118-.446.169-.672Zm11.425-23.865v2.387c-.89-.385-2.034-1.192-2.205-2.816.736.125 1.471.269 2.205.43Zm-17.474-.427c-.17 1.587-1.275 2.395-2.167 2.793v-2.367c.721-.16 1.444-.302 2.168-.426Zm-2.167 6.009v-1.328a6.703 6.703 0 0 0 2-1.038c.906-.698 1.92-1.923 1.963-3.916a44.422 44.422 0 0 1 3.989-.346.886.886 0 1 0-.072-1.77c-1.628.066-3.27.223-4.912.466-.008 0-.015 0-.022.002a48.275 48.275 0 0 0-2.946.534v-5.306a.884.884 0 0 0-.418-.751c-1.26-.785-1.777-1.84-1.453-2.968.347-1.217 1.747-2.448 3.751-2.448h2.9a.885.885 0 0 0 .789-.482c1.062-2.073 3.292-2.834 5.032-2.667 1.655.158 2.889 1.096 3.3 2.51.11.378.456.639.85.639h3.12c2.053 0 3.343 1.24 3.672 2.394.323 1.131-.218 2.233-1.485 3.022a.884.884 0 0 0-.417.751v5.306c-.955-.2-1.912-.37-2.869-.514a.903.903 0 0 0-.113-.02l-.035-.003a47.916 47.916 0 0 0-4.464-.445.887.887 0 0 0-.09 1.77c1.184.06 2.377.172 3.572.328.042 2.08 1.135 3.328 2.11 4.031a6.762 6.762 0 0 0 1.889.934v.855c0 2.324-1.19 4.62-3.349 6.463-1.919 1.638-4.43 2.73-6.555 2.848a2.962 2.962 0 0 1-.16.004c-1.243 0-3.246-.722-5.133-2.027a13.851 13.851 0 0 1-1.652-1.335c-1.273-1.205-2.792-3.137-2.792-5.493Zm9.577 10.627c.087 0 .174-.003.258-.008 1.814-.101 3.788-.76 5.584-1.826.26.384.583.766.989 1.096-1.446 1.675-4.51 2.342-7.152 2.24-2.746-.105-5.056-.981-6.063-2.244.41-.335.733-.722.995-1.11 1.865 1.144 3.853 1.852 5.389 1.852Zm-9.177.255c.258-.01.5-.035.73-.074v3.925h-2.27v-3.722c.489-.06 1-.104 1.54-.13Zm-3.31.45v3.4h-4.79c.856-1.688 2.44-2.814 4.79-3.4ZM2.992 44.41a1.226 1.226 0 0 1 0-2.452h1.453c-.103.517-.084 1.12.062 1.78v.001c.05.227.107.45.168.671H2.993Zm9.861 6.905c-3.39-1.388-5.798-4.28-6.617-7.96-.15-.678-.08-1.16.049-1.32.019-.023.062-.076.255-.076H28.12c.195 0 .238.053.256.076.129.16.198.641.049 1.32-.792 3.573-3.226 6.537-6.53 7.96h-9.04Zm16.377 1.465a2.62 2.62 0 0 0-2.348-1.465h-1.527a13.104 13.104 0 0 0 4-5.134h2.31a3.001 3.001 0 0 0 2.936-2.39h9.024c.591 0 .744.805.76.901l1.397 8.088H29.23ZM57.5 49.332v3.46a2.82 2.82 0 0 1-2.815 2.818h-1.619a1.2 1.2 0 0 1-1.196-1.202v-6.696a1.195 1.195 0 0 1 .447-.932c.206-.166.466-.266.749-.266h1.619a2.82 2.82 0 0 1 2.815 2.818Zm-6.36-20.43v-7.71c0-.92.747-1.668 1.665-1.668h3.76c.918 0 1.665.748 1.665 1.667v7.712c0 .92-.747 1.667-1.665 1.667h-3.76a1.668 1.668 0 0 1-1.665-1.667Z"
          fill="url(#i)"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={9.503}
          y1={27.283}
          x2={9.503}
          y2={35.291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={14.402}
          y1={22.535}
          x2={14.402}
          y2={30.542}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={27.955}
          y1={21.774}
          x2={27.955}
          y2={24.003}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={35.128}
          y1={21.774}
          x2={35.128}
          y2={24.003}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={31.627}
          y1={7.304}
          x2={31.627}
          y2={13.142}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={25.614}
          y1={9.142}
          x2={25.614}
          y2={14.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={37.639}
          y1={9.142}
          x2={37.639}
          y2={14.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={30}
          y1={1.641}
          x2={30}
          y2={58.359}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97CC3B" />
          <stop offset={1} stopColor="#F99C1D" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h60v60H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconCheck() {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.86317 9.67506C1.05939 9.47449 0.245204 9.96348 0.0446289 10.7673C-0.155946 11.571 0.333047 12.3852 1.13683 12.5858L1.86317 9.67506ZM7.65873 16L6.28041 16.5918C6.53098 17.1754 7.12195 17.5379 7.75575 17.4969C8.38954 17.4558 8.92877 17.02 9.10191 16.4089L7.65873 16ZM21.8261 3.46413C22.6347 3.28406 23.1442 2.48257 22.9641 1.67395C22.7841 0.865328 21.9826 0.355791 21.1739 0.535866L21.8261 3.46413ZM1.13683 12.5858C1.52764 12.6833 2.62299 13.151 3.7778 13.9426C4.93988 14.7393 5.88906 15.6803 6.28041 16.5918L9.03705 15.4082C8.31094 13.7171 6.80157 12.3783 5.47406 11.4682C4.13927 10.5532 2.71399 9.88737 1.86317 9.67506L1.13683 12.5858ZM9.10191 16.4089C9.6359 14.5244 10.9948 11.6585 13.1727 9.06395C15.3445 6.47675 18.2417 4.26235 21.8261 3.46413L21.1739 0.535866C16.7583 1.5192 13.3275 4.21342 10.8749 7.13514C8.42852 10.0495 6.86674 13.2929 6.21555 15.5911L9.10191 16.4089Z"
        fill="#fef4ca"
      />
    </svg>
  );
}
